import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _Form from "antd/es/form";
import React, { Component } from 'react';
import Scale from '../../common/Question/Scale';
import NewScale from '../../common/Question/NewScale';
var FormItem = _Form.Item;
var ScalePC = /*#__PURE__*/function (_Component) {
  _inherits(ScalePC, _Component);
  function ScalePC() {
    _classCallCheck(this, ScalePC);
    return _possibleConstructorReturn(this, _getPrototypeOf(ScalePC).apply(this, arguments));
  }
  _createClass(ScalePC, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        question = _this$props.question,
        label = _this$props.label;
      var custom = question.custom;
      var min = custom.min,
        max = custom.max,
        styleType = custom.styleType,
        descriptionType = custom.descriptionType;
      var labels = [];
      for (var i = min.num; i <= max.num; i++) {
        labels.push(i);
      }
      if (!custom[min.num]) {
        custom[min.num] = min;
      }
      if (!custom[max.num]) {
        custom[max.num] = max;
      }
      return React.createElement(Scale, this.props, function (_ref) {
        var error = _ref.error,
          onChange = _ref.onChange,
          marks = _ref.marks,
          max = _ref.max,
          min = _ref.min,
          formAnswer = _ref.formAnswer,
          options = _ref.options;
        return React.createElement(FormItem, {
          label: label,
          required: question.required,
          validateStatus: error ? 'error' : null,
          hasFeedback: true,
          help: error
        }, React.createElement("div", null, React.createElement(NewScale, {
          device: "pc",
          style: {
            // width: max.num - min.num < 6 && styleType !== 'slider' ? '50%' : '100%',
            width: '100%'
          },
          question: question,
          descriptionType: descriptionType,
          styleType: styleType,
          min: min,
          max: max,
          marks: marks,
          onChange: onChange,
          selected: formAnswer.degree,
          options: options
        })));
      });
    }
  }]);
  return ScalePC;
}(Component);
export { ScalePC as default };